// extracted by mini-css-extract-plugin
export default {"loadingError":"LoadingError_loadingError__J7Qvg","label":"LoadingError_label__QyNMB","okButton":"LoadingError_okButton__g-nuI"};